// import React, { useState, useEffect } from "react";
// import { GoogleApiWrapper, Map, Marker, InfoWindow } from "google-maps-react";

// const mapStyles = {
//   width: "100%",
//   height: "100%",
// };

// const LoadingContainer = () => <div>Loading...</div>;

// const GoogleMark = (props) => {
//   const [activeMarker, setActiveMarker] = useState(null);
//   const [selectedPlace, setSelectedPlace] = useState({});
//   const [showingInfoWindow, setShowingInfoWindow] = useState(false);
//   const [mapCenter, setMapCenter] = useState({ lat: 22.2799, lng: 114.1733 });
//   const [shouldRenderMap, setShouldRenderMap] = useState(false); // Delay flag

//   const handleMarkerClick = (props, marker) => {
//     setSelectedPlace(props);
//     setActiveMarker(marker);
//     setShowingInfoWindow(true);
//   };

//   const handleMapClick = () => {
//     if (showingInfoWindow) {
//       setShowingInfoWindow(false);
//       setActiveMarker(null);
//     }
//   };

//   useEffect(() => {
//     if (props.places_map_data?.results?.length > 0) {
//       const { lat, lng } = props.places_map_data.results[0].geometry.location;
//       setMapCenter({ lat, lng });

//       // Delay rendering by 2 seconds
//       const timer = setTimeout(() => {
//         setShouldRenderMap(true);
//       }, 2000);

//       return () => clearTimeout(timer);
//     }
//   }, [props.places_map_data]);

//   return (
//     <div className="goglemark_map">
//       <div id="gmaps-markers" className="gmaps" style={{ position: "relative" }}>
//         {!shouldRenderMap ? (
//           <LoadingContainer />
//         ) : (
//           <Map
//             google={props.google}
//             zoom={10}
//             style={mapStyles}
//             initialCenter={mapCenter}
//             onClick={handleMapClick}
//           >
//             {props?.places_map_data?.results?.map((marker, index) => (
//               <Marker
//                 key={index}
//                 position={marker.geometry.location}
//                 name={marker.name}
//                 address={marker.formatted_address}
//                 rating={marker.rating}
//                 reviews={marker.user_ratings_total}
//                 openNow={marker.opening_hours?.open_now}
//                 onClick={handleMarkerClick}
//               />
//             ))}

//             <InfoWindow marker={activeMarker} visible={showingInfoWindow}>
//               <div>
//                 <h6>{selectedPlace.name}</h6>
//               </div>
//             </InfoWindow>
//           </Map>
//         )}
//       </div>
//     </div>
//   );
// };

// export default GoogleApiWrapper({
//   apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
//   LoadingContainer: LoadingContainer,
//   v: "3",
// })(GoogleMark);

import React, { useEffect, useRef } from "react";

const GoogleMark = ({ places_map_data }) => {
  const mapRef = useRef(null);

  useEffect(() => {
    if (!places_map_data?.results?.length) return;

    const defaultCenter = places_map_data.results[0].geometry.location;

    const map = new window.google.maps.Map(mapRef.current, {
      center: defaultCenter,
      zoom: 13,
    });

    places_map_data.results.forEach((place) => {
      const marker = new window.google.maps.Marker({
        position: place.geometry.location,
        map,
        title: place.name,
      });

      const infoWindow = new window.google.maps.InfoWindow({
        content: `<div><strong>${place.name}</strong><br/>${place.formatted_address}</div>`,
      });

      marker.addListener("click", () => {
        infoWindow.open(map, marker);
      });
    });
  }, [places_map_data]);

  return (
    <div className="goglemark_map" style={{ marginTop: "40px" }}>
      <div
        className="googlemark gmaps"
        ref={mapRef}
        style={{ height: "400px", width: "100%" }}
      />
    </div>
  );
};

export default GoogleMark;